export default __webpack_public_path__ + "static/media/right_sidebar_customer.0320d483.svg";